export const ENDPOINT = `${process.env.NEXT_PUBLIC_API_ROOT_URL}`;
